export const REGULATION_STATUS = {
  WAITING: 'WAITING',
  VALIDATED: 'VALIDATED',
  CANCELED: 'CANCELED',
} as const

export type RegulationStatus = (typeof REGULATION_STATUS)[keyof typeof REGULATION_STATUS]
